import es from '../JsonLang/es.json'
export const lang = { ...es }